import { useEffect, forwardRef, useRef } from "react";

export const Audio = forwardRef((props, ref) => {
  const { srcObject, ...rest } = props;

  const localRef = useRef(null);
  const chosenRef = ref || localRef;

  useEffect(() => {
    if (!srcObject || !chosenRef.current) return;

    chosenRef.current.srcObject = srcObject;
    chosenRef.current
      .play()
      .then(() => {
        console.log("Automatic playback started!");
      })
      .catch((err) => {
        console.log("Failed to play automatically:", err);
      });
    chosenRef.current.volume = 1;
  }, [srcObject, chosenRef]);

  return <audio ref={chosenRef} {...rest} />;
});
